// removed by extract-text-webpack-plugin
module.exports = {"menu":"styles-menu__menu___30pMX","slideFromRight":"styles-menu__slideFromRight___3lwwZ","fadein":"styles-menu__fadein___EtJEL","item":"styles-menu__item___3hq3Y","link":"styles-menu__link___2Chhs","rotate":"styles-menu__rotate___27C1d","waves":"styles-menu__waves___uPDDx"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/Landing/styles-menu.scss
// module id = ./resources/assets/js/containers/Landing/styles-menu.scss
// module chunks = 0